import { useFormContext } from "react-hook-form";
import { useGetFreightModesConfig } from "api/queries/location/useGetFreightModesConfig";
import usePermissions from "hooks/usePermissions";

export default function useGetNotifyPartyAndConsignee() {
  const { watch } = useFormContext();
  const { permissions } = usePermissions();
  const { notify_party_and_consignee } = permissions ? JSON.parse(permissions)?.company_shipper_settings : null;

  const paymentLocation = watch("organizational.location");
  const { data } = useGetFreightModesConfig(paymentLocation);
  const availableModes = data?.freight_modes?.available_modes ?? [];

  const invited_modes = watch("invited_modes") || {};

  const hasAtLeastOneAirOrOceanAux = (keyToCheck: string) =>
    availableModes.some((mode) => keyToCheck === mode.value && ["air", "ocean"].includes(mode.type));

  const hasAtLeastOneAirOrOcean = Object.entries(invited_modes ?? {}).some(([key, value]) => {
    if (key === "custom" && Array.isArray(value)) {
      return value.some((customMode) => {
        if (customMode?.value === true) {
          const keyToCheck = `custom_${customMode?.key}`;
          return hasAtLeastOneAirOrOceanAux(keyToCheck);
        }
        return false;
      });
    }

    if (value === false) return false;
    return hasAtLeastOneAirOrOceanAux(key);
  });

  const isNotifyPartyAndConsignee = notify_party_and_consignee && hasAtLeastOneAirOrOcean;

  return { isNotifyPartyAndConsignee };
}
